import { createSelector } from 'reselect'

import { cartWithProductNames } from '~/utils/cart'

import type { AppState } from '../reducers'
import type { Cart, CartState } from '~/types'

export const getCartState = (state: AppState): CartState => state.cart

const cartWithProductNamesSelector = createSelector(
  getCartState,
  (cartState: CartState | null | undefined): CartState | null | undefined => {
    return cartState ? cartWithProductNames(cartState) : null
  },
)

const getCartUI = (state) => state.ui.cart

export const getCurrency = (state: { cart: CartState }) =>
  state.cart.payloadCurrency

export const cartSelector: (arg0: AppState) => Cart = createSelector(
  cartWithProductNamesSelector,
  getCartUI,
  (cart, ui) => ({ ...cart, ui }),
)
